import { withResult } from 'feathers-fletching';
import { disallow } from 'feathers-hooks-common';

const withResults = withResult({
  position: (result) => {
    if (result.latitude && result.longitude) {
      return {
        lat: Number(result.latitude),
        lng: Number(result.longitude)
      };
    }
  }
});

export default {
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [disallow()],
    patch: [disallow()],
    remove: [disallow()]
  },
  after: {
    all: [withResults],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
};
